// A value as one CSV field: quoted when it holds a comma, quote or line break,
// so it cannot spill into the next column. Empty for null / undefined.
const csvField = (value: unknown) => {
  if (value === null || value === undefined) return ''
  const s = String(value)
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

/** Rows to CSV text; the first row's keys are the columns, in that order. */
export const toCSV = (rows: Record<string, unknown>[]) => {
  const columns = Object.keys(rows[0])
  const lines = [columns.map(csvField).join(',')]
  for (const row of rows)
    lines.push(columns.map(c => csvField(row[c])).join(','))
  return lines.join('\n') + '\n'
}

export const downloadCSV = (data: any, name: string) => {
  if (!data.length) {
    throw new Error('No data provided')
  }

  const rows = typeof data !== 'object' ? JSON.parse(data) : data
  // The byte-order mark makes Excel read the file as UTF-8 (accented names).
  const blob = new Blob(['﻿' + toCSV(rows)], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${name}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
